import React, { FC, useMemo } from 'react';
import { InfoLabel } from '@cubeyou-team/hx-react-components';

import {
  dataSourceLabelMap,
  DATA_SOURCE_IDS,
  DATA_SOURCE_LABELS,
  fusionTypeLabelMap,
  DATA_SOURCE_COLOR_RGB_MAP,
} from '@discover-frontend/constants';
import { getBackgroundColor } from '../../utils';

interface QueryBadgeProps {
  source: string;
  dataSourceBadge?: boolean;
}

const getItemSourceLabel = (source: string) => {
  const fusionTypeToLabelMap = {
    ...fusionTypeLabelMap,
    [DATA_SOURCE_IDS.TWITTER]: DATA_SOURCE_LABELS.DISCOVER,
    [DATA_SOURCE_IDS.DISCOVER]: DATA_SOURCE_LABELS.DISCOVER,
    [DATA_SOURCE_IDS.SAVED_QUERIES]: DATA_SOURCE_LABELS.SAVED_QUERIES,
  };

  return fusionTypeToLabelMap[source] || source;
};

export const QueryBadge: FC<QueryBadgeProps> = ({
  source,
  dataSourceBadge,
}) => {
  const itemSourceLabel = useMemo(() => {
    if (dataSourceBadge) return dataSourceLabelMap[source];

    return getItemSourceLabel(source);
  }, [source, dataSourceBadge]);

  const bgColor = useMemo(() => {
    if (dataSourceBadge) return DATA_SOURCE_COLOR_RGB_MAP[source];

    return getBackgroundColor(source);
  }, [source, dataSourceBadge]);

  return (
    <InfoLabel
      label={itemSourceLabel}
      variant="dark_light"
      className="text-white"
      style={{ backgroundColor: bgColor }}
    />
  );
};
